import { Avatar } from 'primereact/avatar';
import React from 'react';

interface UserAvatarSmallDatamodel {
  imageUrl: string;
  firstName: string | undefined;
  lastName: string | undefined;
}
export const UserAvatarSmall: React.FC<UserAvatarSmallDatamodel> = ({
  imageUrl,
  firstName,
  lastName,
}) => {
  const getRandomColor = () => {
    const colors = [
      '#FF6B6B', // Red
      '#4ECDC4', // Teal
      '#FFD166', // Yellow
      '#6B8DE3', // Blue
      '#C8553D', // Rust
      '#7FB069', // Green
      '#9B72B0', // Purple
      '#58A4B0', // Light Blue
      '#F7B32B', // Orange
      '#56AB91', // Seafoam
    ];

    return colors[Math.floor(Math.random() * colors.length)];
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '4px',
      }}
    >
      {' '}
      <Avatar
        image={imageUrl}
        /*onClick={() => setAddAvatar(true)}*/
        label={
          firstName && lastName
            ? firstName?.charAt(0) + lastName?.charAt(0)
            : ''
        }
        size="large"
        shape="circle"
        style={{ backgroundColor: getRandomColor(), color: 'white' }}
      />
    </div>
  );
};
